module.exports = __webpack_public_path__ + "img/contracts.ccbc5e16.svg";